<!-- src/components/Watermark.vue -->
<template>
  <div class="watermark-container" v-if="visible" ref="watermark"></div>
</template>

<script>
export default {
  name: 'Watermark',
  props: {
    text: {
      type: String,
      default: ''
    },
    fontSize: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.08)'
    },
    rotate: {
      type: Number,
      default: -25
    },
    gapX: {
      type: Number,
      default: 200
    },
    gapY: {
      type: Number,
      default: 150
    },
    zIndex: {
      type: Number,
      default: 9999
    }
  },
  data() {
    return {
      visible: true,
      observer: null
    }
  },
  computed: {
    watermarkText() {
      return this.text || '未登录用户'
    }
  },
  mounted() {
    this.initWatermark()
    this.startObserving()
  },
  beforeDestroy() {
    this.stopObserving()
  },
  methods: {
    initWatermark() {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // 设置画布大小
      canvas.width = this.gapX
      canvas.height = this.gapY

      // 绘制水印文字
      ctx.font = `${this.fontSize}px "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial, sans-serif`
      ctx.fillStyle = this.color
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'

      // 旋转画布
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate((this.rotate * Math.PI) / 180)
      ctx.fillText(this.watermarkText, 0, 0)

      // 将canvas转换为背景图
      const watermarkUrl = canvas.toDataURL('image/png')

      const watermarkDiv = this.$refs.watermark
      watermarkDiv.style.position = 'fixed'
      watermarkDiv.style.top = '0'
      watermarkDiv.style.left = '0'
      watermarkDiv.style.width = '100%'
      watermarkDiv.style.height = '100%'
      watermarkDiv.style.pointerEvents = 'none' // 让水印不干扰点击
      watermarkDiv.style.zIndex = this.zIndex
      watermarkDiv.style.backgroundImage = `url(${watermarkUrl})`
      watermarkDiv.style.backgroundRepeat = 'repeat'
      watermarkDiv.style.backgroundPosition = 'center'
    },

    // 监听DOM变化，防止水印被删除
    startObserving() {
      const watermarkDiv = this.$refs.watermark
      if (!watermarkDiv) return

      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // 如果水印被删除或样式被修改，重新初始化
          if (mutation.type === 'attributes' ||
              (mutation.type === 'childList' && !document.body.contains(watermarkDiv))) {
            this.initWatermark()
          }
        })
      })

      this.observer.observe(watermarkDiv, {
        attributes: true,
        childList: true,
        subtree: true
      })

      // 同时监听body的变化
      const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const removed = Array.from(mutation.removedNodes)
            if (removed.includes(watermarkDiv)) {
              // 水印被删除，重新添加到body
              document.body.appendChild(watermarkDiv)
            }
          }
        })
      })

      bodyObserver.observe(document.body, {
        childList: true
      })

      // 保存observer以便销毁
      this.bodyObserver = bodyObserver
    },

    stopObserving() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
      if (this.bodyObserver) {
        this.bodyObserver.disconnect()
        this.bodyObserver = null
      }
    },

    // 刷新水印（可对外暴露）
    refresh() {
      this.initWatermark()
    }
  }
}
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}
</style>